﻿if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      if (!this.classList.contains('tap-product-modal')) return;
      this.querySelector('[data-tap-media-prev]')?.addEventListener('click', () => this.moveMedia(-1));
      this.querySelector('[data-tap-media-next]')?.addEventListener('click', () => this.moveMedia(1));
      this.addEventListener('keydown', event => {
        if (event.target.closest('video, iframe, model-viewer, input')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.moveMedia(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      this.addEventListener('touchstart', event => {
        this.touchStart = event.touches.length === 1 && event.target.matches('img')
          ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      this.addEventListener('touchend', event => {
        if (!this.touchStart) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.moveMedia(dx < 0 ? 1 : -1);
        this.touchStart = null;
      }, { passive: true });
      this.addEventListener('click', event => {
        if (event.target.classList.contains('product-media-modal__content')) this.hide();
      });
    }

    moveMedia(direction) {
      const items = [...this.querySelector('.product-media-modal__content').children].filter(item => item.dataset.mediaId);
      if (!items.length) return;
      const current = items.findIndex(item => item.classList.contains('active'));
      const next = items[(current + direction + items.length) % items.length];
      window.pauseAllMedia();
      items.forEach(item => item.classList.toggle('active', item === next));
      this.updateMediaCount();
    }

    updateMediaCount() {
      const counter = this.querySelector('[data-tap-media-count]');
      if (!counter) return;
      const items = [...this.querySelector('.product-media-modal__content').children].filter(item => item.dataset.mediaId);
      counter.textContent = (items.findIndex(item => item.classList.contains('active')) + 1) + ' / ' + items.length;
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const id = this.openedBy.getAttribute('data-media-id');
      this.querySelectorAll('[data-media-id]').forEach(element => element.classList.toggle('active', element.dataset.mediaId === id));
      const activeMedia = this.querySelector('[data-media-id="' + id + '"]');
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      if (!this.classList.contains('tap-product-modal')) {
        activeMedia.scrollIntoView();
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      }
      this.updateMediaCount();
      if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaContent?.querySelector('.js-youtube')) activeMedia.loadContent();
    }
  });
}

